<template>
<div :class="{'is-hidden': !active}"
      class="has-text-centered">
  <font-awesome-icon icon="spinner"
                     size="3x"
                     spin></font-awesome-icon>
</div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    active: {
      type: Boolean,
      default: true
    }
  }
};
</script>
